// i18n area 'storage' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.pt-PT.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 arquivo→«cópia de configuração» (#247).
import type { enUS } from './storage'

export const ptPT: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Criar storage',
      path: 'Caminho',
      pathHint: 'Caminho absoluto sob uma root permitida (default /var/lib/tvirt/pools/)',
      shared: 'Storage partilhado',
      sharedChip: 'partilhado',
      sharedVerifiedChip: 'partilhado · verificado',
      sharedVerifiedTooltip: 'Partilha verificada: as sondas cruzadas confirmam que cada membro vê os dados escritos pelos outros.',
      sharedDisputedChip: 'partilhado · NÃO verificado',
      sharedDisputedTooltip: 'Partilha NÃO verificada',
      sharedDisputedPair: '{observer} não vê os dados escritos por {writer}',
      sharedHint: 'Share de rede montada localmente no mesmo path em cada membro — pré-requisito da live migration (declarativo).',
      sharedDanger: 'PERIGO — o TVirt ACREDITA nesta flag: ao ligá-la, cada membro assume que vê OS MESMOS bytes neste path. Numa pasta que NÃO é uma share verdadeiramente partilhada (NFS/CIFS/filesystem de cluster) o resultado é corrupção e perda de dados à primeira migração ou ao primeiro reinício HA noutro nó. Ligue-a apenas se o path for uma share montada de forma idêntica em cada nó.',
      type: 'Tipo',
      capacity: 'Capacidade',
      provisioned: 'Alocada',
      provisionedOvercommit: 'Compromisso potencial além da capacidade: os volumes thin podem crescer até {n} GiB.',
      phase: { ready: 'Pronto', degraded: 'Degradado', error: 'Erro' },
      tabConfig: 'Configuração',
      tabCapacity: 'Capacidade e estado',
      cardIdentity: 'Identidade',
      cardPlacement: 'Colocação',
      cardConnection: 'Ligação',
      usedReal: 'Ocupação real',
      capacityUnknown: 'O nó ainda não reportou a capacidade deste pool — aqui não se inventam números',
      overcommitHint: 'Compromisso além da capacidade: legítimo nos pools thin, vigie a ocupação real',
      supportedContent: 'Conteúdos suportados',
      content: {
        disks: 'Discos',
        catalogFiles: 'Ficheiros de catálogo',
        backups: 'Backups',
        appVolumes: 'Volumes de App'
      },
      defaultDiskFormat: 'Formato de disco predefinido',
      reserveGiB: 'Espaço livre reservado (GiB)',
      available: 'Disponível',
      diskCount: 'Discos',
      filesystem: 'Filesystem',
      observedAt: 'Observado em',
      lostAtRow: 'Declarado perdido em',
      sharedProbeRow: 'Verificação de partilha',
      sharedProbeNodes: 'Nós sondados',
      reachableFrom: 'Alcançabilidade declarada',
      reachableFromHint: 'Os nós a partir dos quais este storage tem de ser alcançável. Uma VM com discos, ISOs ou metadados aqui não arranca nem migra para um nó fora desta lista. Todos os membros vêm pré-selecionados: restrinja como quiser. Um nó que entra no cluster mais tarde fica de fora até que o adicione aqui.',
      reachableFromNone: 'não declarada',
      reachableFromTags: 'Alcançabilidade por tag',
      reachableFromTagsHint: 'Seletor tag=valor (entradas separadas por vírgulas, em AND): cada membro que carrega estas tags fica declarado alcançável — dinamicamente: etiquetar um nó fá-lo entrar.',
      reachableFromTagsInvalid: 'Formato inválido — use tag=valor, separados por vírgulas',
      reachableResolved: 'Nós resolvidos: {nodes}',
      reachableDeclaredNotSeen: 'declarado mas não visto pela sonda de partilha em: {nodes}',
      reachableSeenNotDeclared: 'visto mas não declarado (fora do perímetro) em: {nodes}',
      cephCluster: 'Cluster Ceph gerido',
      appGuardTitle: 'Storage em uso pelas Apps',
      appEphemeralGuard: 'este storage é o pool efémero de cluster das Apps — mude-o primeiro na página Apps e depois elimine-o.',
      appInUseGuard: 'aqui vivem roots/volumes de apps: {apps} — mova-os ou elimine-os primeiro.',
      releaseRequiredTitle: "Eliminar '{name}' e libertar as suas imagens?",
      releaseRequiredBatchTitle: 'Eliminar os storages selecionados e libertar as suas imagens?',
      releaseRequiredBody: 'Libertar as imagens não apaga NENHUM byte: o cancelamento do registo deixa o namespace no disco, as imagens deixam simplesmente de estar materializadas e cada referência dos scopes sobrevive como claim — registe de novo o pool e são readotadas.',
      releaseConfirm: 'Eliminar e libertar as imagens'
    },
    lost: {
      chip: 'Perdido',
      action: 'Declarar perdido',
      confirmTitle: 'Declarar o storage perdido',
      confirmBody: 'Atestação do operador por sua conta e risco declarado: cada task em fila ou em curso sobre este storage ou os seus objetos irá FALHAR, as eliminações passam a ser apenas de registo (nenhum trabalho no filesystem) e o novo trabalho físico é recusado. Os bytes nunca são tocados — se o volume voltar à vida, registe-o de novo e execute um scan para readotar tudo.',
      confirmSubmit: 'Declarar perdido',
      error: 'A atestação foi recusada'
    },
    findings: {
      action: 'Objetos encontrados',
      title: 'Objetos encontrados',
      empty: 'Nenhum objeto encontrado no namespace do storage',
      loadError: 'Não foi possível carregar os objetos encontrados',
      actionError: 'A decisão foi recusada',
      colKind: 'Tipo',
      colObject: 'Objeto',
      colConflict: 'Conflito',
      namespaceNotice:
        'Este diretório já tinha sido inicializado por outro armazenamento: o selo de identidade foi reescrito com o deste armazenamento. Os conteúdos NÃO foram tocados — vê os objetos encontrados abaixo, importa os que precisas e depois dispensa este aviso.',
      kind: {
        disk: 'Disco',
        catalogFile: 'Ficheiro de catálogo',
        vmMetadata: 'Metadata VM',
        namespace: 'Namespace',
        foreign: 'Estranho',
        volumeGroup: 'Grupo de volumes'
      },
      vgAdopt: {
        action: 'Adotar o grupo de volumes',
        title: 'Adotar o grupo de volumes',
        intro:
          'Este dispositivo já tem um grupo de volumes com um nome do TVirt, mas o seu selo não nomeia nenhum storage registado aqui. Pode ser o que um storage anterior DESTE cluster deixou na LUN, ou o que OUTRO cluster TVirt deixou numa LUN que mudou de mãos: daqui os dois casos são idênticos, e é por isso que ninguém decide por si.',
        irreversible: 'Olhe para o dispositivo, o selo e o nome antes de prosseguir: a adoção não se desfaz.',
        device: 'Dispositivo',
        seal: 'Selo',
        sealNone: 'nenhum (sem etiqueta tvirt.storageId)',
        renameTo: 'Será renomeado para',
        renameNone: 'Sem renomeação: o nome já é o que este storage deriva',
        volumesNote:
          'Os volumes contidos NÃO são adotados por este gesto: o próximo scan oferece-os um a um, como objetos encontrados normais.'
      },
      conflictChip: 'ID já existente',
      dismissedChip: 'Ignorado',
      adopt: 'Adotar',
      adoptFileTitle: 'Importar para um catálogo',
      adoptFileHint: 'Os ficheiros só existem dentro dos catálogos: escolha o catálogo de destino para o ficheiro encontrado.',
      purge: 'Eliminar do disco',
      dismiss: 'Ignorar',
      purgeConfirmTitle: 'Eliminar do disco',
      purgeConfirmBody: 'Os bytes encontrados de {id} serão removidos do storage. A operação não é reversível.',
      taskStarted: 'Iniciado — prossegue como task em background',
      scan: 'Fazer scan ao storage',
      scanStarted: 'Scan iniciado…',
      scanDone: 'Scan concluído — os objetos encontrados estão atualizados'
    },
    reinit: {
      action: 'Repetir inicialização'
    },
    wizard: {
      addButton: 'Adicionar',
      title: 'Adicionar storage',
      back: 'Voltar',
      continue: 'Continuar',
      selectHint: 'Selecione um protocolo para ver como o TVirt o usa.',
      roadmap: 'Roadmap',
      server: 'Servidor',
      export: 'Caminho exportado',
      share: 'Share',
      username: 'Nome de utilizador',
      password: 'Palavra-passe',
      passwordHint: 'Só de escrita: usada para o mount, nunca mais mostrada.',
      credential: 'Credencial',
      credentialManual: 'Introduzir manualmente',
      credentialHint: 'Uma entrada do keystore do tipo username e password — a alternativa a digitá-los aqui.',
      credentialEmpty: 'Nenhuma credencial do tipo username e password no keystore — crie-a em Sistema → Credenciais, ou digite a conta aqui em baixo.',
      options: 'Opções de mount',
      optionsHint: 'Separadas por vírgula, passadas ao mount -o tal como estão.',
      portal: 'Portal',
      portalHint: 'host[:porta] — a porta predefinida é 3260.',
      target: 'Target IQN',
      targetHint: 'O nome do target iSCSI, começa por iqn.',
      lun: 'LUN',
      wholeLunRow: 'Nos discos: este storage nomeia só o target',
      wholeLunHint: 'Este storage nomeia só o target: as suas LUN tornam-se discos uma a uma (Criar disco → adotar uma LUN inteira), no target nada é escrito.',
      lunHint: 'Número da LUN no target — 0 em caso de dúvida.',
      chapCredential: 'Credencial (CHAP)',
      chapCredentialHint: 'Uma entrada do keystore do tipo CHAP (iSCSI) usada para o login — o segredo nunca viaja com o storage.',
      chapNone: 'Sem autenticação',
      chapEmpty: 'Nenhuma credencial do tipo CHAP (iSCSI) no keystore — crie-a em Sistema → Credenciais. Sem ela, o login fica não autenticado.',
      address: 'Endereço',
      addressHint: 'Host ou IP do target NVMe/TCP (traddr).',
      port: 'Porta',
      portHint: 'Porta TCP do target — 4420 se ficar vazia.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'O NQN do subsystem no target, começa por nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID dentro do subsystem — 1 em caso de dúvida.',
      dhchapCredential: 'Credencial (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Uma entrada do keystore do tipo DH-HMAC-CHAP (NVMe) usada na ligação — o segredo nunca viaja com o storage.',
      dhchapNone: 'Sem autenticação',
      dhchapEmpty: 'Nenhuma credencial do tipo DH-HMAC-CHAP (NVMe) no keystore — crie-a em Sistema → Credenciais. Sem ela, a ligação fica não autenticada.',
      monitors: 'Monitores',
      monitorsHint: 'Endpoints dos monitores Ceph, host[:porta], separados por vírgula ou por linha — porta predefinida 6789.',
      pool: 'Pool',
      poolHint: 'O pool RBD a consumir — uma imagem RBD por disco.',
      fs: 'Filesystem',
      fsHint: 'O nome do filesystem CephFS (mds_namespace no mount).',
      fsPath: 'Path dentro do filesystem',
      fsPathHint: 'Path absoluto dentro do filesystem que o storage monta — / em caso de dúvida.',
      cephxCredential: 'Credencial (cephx)',
      cephxCredentialHint: 'Uma entrada do keystore do tipo cephx: username = nome do client (client.…), secret = a chave base64. Obrigatória.',
      cephxNone: 'Nenhuma credencial cephx no keystore — crie uma (tipo: cephx) em Sistema → Credenciais, ou deixe que um cluster Ceph gerido a cunhe com "Propor como storage".',
      sharedByNature: 'Os storages de rede são partilhados por natureza: cada membro monta-os no mesmo caminho gerido pelo TVirt.',
      error: 'O storage foi recusado',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Outro',
        legacy: 'Legacy'
      },
      legacyHint: 'Suportados a todos os títulos — simplesmente não os escolheríamos para uma instalação nova.',
      proto: {
        dir: {
          name: 'Pasta local',
          desc: 'Uma diretoria do nó: simples e rápida. É LOCAL a um nó, a menos que o path seja uma share verdadeiramente partilhada — marcá-la como partilhada quando não o é custa dados.',
          usage: 'O TVirt guarda aí discos das VMs, imagens ISO/disco e templates.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Um export NFS montado pelo cluster — partilhado por natureza.',
          usage: 'Aloja discos das VMs, imagens ISO/disco e templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Uma share Windows/Samba montada pelo cluster — partilhada por natureza.',
          usage: 'Aloja discos das VMs, imagens ISO/disco e templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Um filesystem remoto via SSH — sem necessidade de export NAS.',
          usage: 'Em roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'LUNs de blocos via IP com LVM partilhado por cima.',
          usage: 'Só discos — um volume thin por disco; não aloja imagens ISO nem templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices distribuídos num cluster Ceph.',
          usage: 'Só discos — uma imagem RBD por disco, aberta nativamente pelo QEMU; não aloja imagens ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'O filesystem distribuído do Ceph, montado pelo kernel no cluster — shared by nature.',
          usage: 'Aloja discos de VM, imagens ISO/disco e templates — a família dir num filesystem Ceph (credencial cephx obrigatória).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUNs SCSI sobre fabric FibreChannel — a SAN FC clássica.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'O mesmo SCSI sobre FibreChannel, com os frames FC encapsulados em Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (LUN inteiras)',
          desc: 'O target iSCSI como portador de LUN inteiras: cada disco É uma LUN, passada em bruto ao guest — sem LVM pelo meio.',
          usage: 'Só discos — uma LUN inteira por disco, adotada tal como está; a casa SAN dos discos de escrita partilhada.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (namespaces inteiros)',
          desc: 'O subsistema NVMe como portador de namespaces inteiros: cada disco É um namespace, passado em bruto ao guest.',
          usage: 'Só discos — um namespace inteiro por disco, adotado tal como está; escrita partilhada sim, persistent reservations SCSI não.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe remoto — nenhum SCSI no caminho — sobre TCP simples, com LVM partilhado por cima.',
          usage: 'Só discos — um volume thin por disco; não aloja imagens ISO nem templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe remoto sobre fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe sobre o fabric FibreChannel que o FCoE transporta dentro do Ethernet — as camadas FCoE e NVMe/FC empilhadas.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI com o caminho de dados movido para RDMA — qualquer fabric (InfiniBand, iWARP, RoCE). Superado pelo NVMe/RDMA, ainda presente nos arrays e no ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'SCSI nativo sobre RDMA, a era pré-iSER: InfiniBand (com discovery de fabric) e RoCE — sobrevive nos storages HPC datados.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'NVMe remoto sobre qualquer fabric RDMA — InfiniBand, iWARP, RoCE v1 e v2: uma única configuração, é o nó que diz qual tem.' },
        s3: { name: 'S3', desc: 'Object storage compatível com S3 — imagens e backups.' }
      }
    },
    catalogs: {
      title: 'Catálogos',
      createTitle: 'Criar catálogo',
      editTitle: 'Editar catálogo',
      docTitle: 'Catálogo',
      notFound: 'Este catálogo não existe (já não?)',
      scopeHint: 'Quem lê este scope vê (e pode usar) todos os ficheiros do catálogo',
      files: 'Ficheiros',
      noFiles: 'Nenhum ficheiro',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'de sistema',
      systemTooltip: 'Catálogo de sistema: aloja os objetos integrados da plataforma e não pode ser alterado'
    },
    catalogFiles: {
      catalog: 'Catálogo',
      kindLabel: 'Tipo',
      physicalSize: 'Tamanho físico',
      virtualSize: 'Tamanho virtual',
      importTemplateAction: 'Importar como VM Template',
      importTemplateLegacy: 'Nenhum formato declarado — utilizável como seed de discos, não importável',
      importTemplateTitle: 'Importar como VM Template',
      importTemplateSubmit: 'Importar',
      importTemplateError: 'O import falhou',
      importTemplateHint: 'O pacote .tvtpl torna-se um VM Template: o hardware congelado do manifest mais um disco por entry do arquivo, cada um verificado contra o seu checksum. NICs e suportes CD/DVD não fazem parte de um arquivo — adicione-os depois do import.',
      importTemplateQcow2Hint: 'Um qcow2 nu torna-se um template de UM disco com o hardware default declarado: perfil linux, UEFI, 2 vCPU, 2048 MiB, boot do seu único disco. Ajuste no deploy.',
      importTemplateName: 'Nome do template',
      importTemplateNameHint: 'Vazio = {name} (-import-<n> se ocupado)',
      importTemplateStorage: 'Storage para os discos',
      importTemplateMetadataStorage: 'Storage de metadados',
      importTemplateMetadataHint: 'Um storage de blocos não aloja os metadados da VM (firmware, varstore) — escolha um dir/nfs/cifs.',
      importTemplateStarted: 'Import iniciado — o template aparece no tab Templates quando a task terminar.',
      kind: {
        iso: 'Imagem ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Template VM',
        'oci-image': 'Imagem OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Imagens ISO',
        'ct-rootfs': 'Templates CT',
        'vm-template': 'Templates VM',
        'oci-image': 'Imagens OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Adicionar imagem ISO',
        'ct-rootfs': 'Registar template CT',
        'vm-template': 'Adicionar template VM',
        'oci-image': 'Adicionar imagem OCI',
        'firmware-ovmf': 'Adicionar firmware OVMF'
      },
      formatHint: 'Derivado da extensão do ficheiro escolhido — corrija-o se adivinhou mal',
      tarballHint: 'Um tarball rootfs no formato LXC standard (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ou um .tar simples)',
      ociArchiveHint: 'Um tarball docker-archive / oci-archive (.tar ou .tar.gz), por exemplo de docker save',
      uploadResumeHint: 'Upload interrompido — o ficheiro está à espera de upload: submeta de novo com o mesmo ficheiro para retomar',
      moveTitle: 'Mover ficheiro',
      moveHint: 'Duas dimensões independentes: o Catálogo move a ligação (mesmo id, nenhum byte se move, o scope passa a ser o do catálogo de destino); o Storage move os dados — cada cópia ligada segue-o, recusado enquanto o ficheiro estiver em uso. Escolhidos em conjunto: primeiro o catálogo, depois o storage.',
      moveCatalog: 'Catálogo de destino',
      moveCatalogHint: 'Só a ligação muda de casa: uma VM que monta o ficheiro tem de conseguir ver o catálogo de destino',
      keepCurrent: 'Não alterar',
      rehomed: 'Ligação movida para o catálogo escolhido',
      copyAction: 'Copiar para um catálogo…',
      copyTitle: 'Copiar para um catálogo',
      copyLinkHint: 'A cópia é uma nova ligação aos mesmos dados — nada é duplicado no storage.',
      copyCatalog: 'Catálogo de destino',
      copyCatalogHint: 'A cópia é a forma como um ficheiro viaja entre catálogos',
      sameCatalog: 'O mesmo da origem',
      sharedObjectHint: 'Os dados deste ficheiro são partilhados por {count} cópias ligadas',
      deleteLastLink: 'Esta é a ÚLTIMA ligação a este conteúdo: os dados também serão eliminados do storage.',
      deleteLinkOnly: 'Só esta ligação será removida — os dados ficam, ainda alcançáveis através das outras cópias ligadas ({count}).',
      noCatalog: 'Não há nenhum catálogo — crie um',
      inlineCatalogName: 'Nome do catálogo',
      embeddedChip: 'integrado',
      embeddedStorage: 'Integrado na plataforma',
      embeddedNoMove: 'Ficheiro integrado da plataforma: não vive em nenhum storage — clone-o em vez disso',
      embeddedCopyHint: 'O clone materializa os bytes integrados num storage real: escolha o storage e o catálogo de destino — a cópia é um ficheiro normal',
      sourceEmbedded: 'Integrado na plataforma',
      nodesRow: 'Presença por nó',
      nodesSummary: '{present} de {total} nós têm-no',
      nodePresent: 'presente',
      nodeMissing: 'ausente',
      nodeUnknown: 'ainda não reportado',
      nodesHint: 'O asset vive no disco de cada nó (pacote trantor-tvirt-assets): um nó que não o tem não pode definir uma VM com este firmware nem servir as Guest Tools. Versões diferentes entre nós são normais durante uma atualização progressiva.',
      downloadAction: 'Transferir',
      downloadNotReady: 'O conteúdo ainda não está pronto — o download exige um ficheiro ready',
      downloadDenied: 'O seu papel não inclui catalog.download — transferir os bytes é um direito separado do uso do ficheiro',
      objectRow: 'Objeto de storage',
      objectLinksRow: 'Cópias ligadas',
      declaredChecksum: 'SHA-256 declarado',
      usedByRow: 'Usado por',
      usedByVms: 'VMs',
      usedByDisks: 'Discos',
      transferRow: 'Transferência',
      storageLockHint: 'Só muda através da ação Mover'
    },
    objects: {
      action: 'Explorar conteúdos',
      title: 'Conteúdos do storage',
      hint: 'Censo só de leitura do que vive neste storage — cada objeto gere-se na sua própria secção.',
      empty: 'Nenhum objeto registado neste storage',
      loadError: 'Não foi possível carregar os conteúdos',
      colDetail: 'Detalhe',
      manage: 'Gerir na sua secção',
      kind: {
        disk: 'Disco',
        catalogFile: 'Ficheiro de catálogo',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata VM',
        appRoot: 'Root de App',
        appVolume: 'Volume de App'
      }
    },
    inventory: {
      tabCatalogs: 'Catálogos',
      storage: 'Storage',
      sizeGib: 'Tamanho (GiB)',
      format: 'Formato',
      size: 'Tamanho',
      sourceType: 'Origem',
      sourceFile: 'Upload de ficheiro',
      sourceUrl: 'Download de URL',
      file: 'Ficheiro',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Obrigatório: o download é verificado contra este SHA-256',
      verifyChecksum: 'Verificar checksum',
      checksumOffHint: 'O download será aceite sem verificação — o SHA-256 calculado é registado na mesma',
      uploading: 'A carregar…',
      move: {
        action: 'Mover',
        diskTitle: 'Mover disco',
        target: 'Storage de destino',
        diskHint: 'O disco mantém a sua identidade: os bytes viajam para o storage escolhido. Uma VM que o use tem de estar desligada; com snapshots presentes, um lado iSCSI recusa a mudança.',
        noTargets: 'Nenhum storage de destino compatível',
        submit: 'Mover',
        error: 'A mudança foi recusada'
      },
      clone: {
        action: 'Clonar',
        title: 'Clonar disco',
        name: 'Nome da cópia',
        storage: 'Storage de destino',
        sameStorage: 'O mesmo da origem',
        linked: 'Linked clone',
        linkedHint: 'Overlay qcow2 instantâneo encadeado ao disco de origem (só origens qcow2). O default é uma cópia completa.',
        linkedCrossHint: 'Um linked clone tem de ficar no storage da origem: escolha "O mesmo da origem" para o ativar.',
        submit: 'Clonar',
        error: 'A clonagem foi recusada'
      },
      copy: {
        action: 'Copiar',
        name: 'Nome da cópia',
        storage: 'Storage de destino',
        sameStorage: 'O mesmo da origem',
        submit: 'Copiar',
        error: 'A cópia foi recusada'
      },
      taskStarted: 'Iniciado — prossegue como task em background',
      cephObjects: 'Ir para os detalhes do objeto no Ceph',
      phase: {
        ready: 'Pronta',
        creating: 'Em criação',
        'awaiting-upload': 'À espera de upload',
        downloading: 'Em download',
        verifying: 'Em verificação',
        deleting: 'Em eliminação',
        error: 'Erro',
        'in-use': 'Em uso'
      }
    }
  }
}
